"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgSauna = function SvgSauna(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 4)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    d: "M.5 10.5h17v6H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.682 11.565c-.614.612-.789.768-.56 1.943.23 1.174.726 2.096-.304 2.409-1.03.313-1.419-.463-1.723-2.41-.304-1.946.18-2.653.624-3.056.13-.118.42-.451 1.1-.451.678 0 1.666.766.863 1.565z",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29 11.561c.615.612.844.772.615 1.947-.229 1.174-.725 2.096.304 2.409 1.03.313 1.419-.463 1.723-2.41.304-1.946-.18-2.653-.624-3.056-.13-.118-.42-.451-1.099-.451s-1.72.762-.918 1.561z",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.637 4.648A2.5 2.5 0 0 0 6.243 6.43l-.248.825a1.802 1.802 0 0 0 1.726 2.32h2.702a1.802 1.802 0 0 0 1.726-2.32L11.9 6.43a2.5 2.5 0 0 0-2.395-1.782h-.869z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4A4A4A",
    cx: 9.072,
    cy: 2.074,
    r: 2.074
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.037 7.725h2.538a1 1 0 0 1 1 1v.991",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.523 8.03C-.174 6.894-.174 5.884.523 5m3 3.03c-.697-1.136-.697-2.146 0-3.03M1.477 3.03c.697-1.136.697-2.146 0-3.03m13.046 8.03c-.697-1.136-.697-2.146 0-3.03m3 3.03c-.697-1.136-.697-2.146 0-3.03m-2.046-1.97c.697-1.136.697-2.146 0-3.03",
    stroke: "#4D4D4D"
  })));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgSauna);
var _default = Memo;
exports["default"] = _default;